import React, { PureComponent } from "react";
import { connect } from 'react-redux';
import { Link } from "react-router-dom";
import { compose } from "redux";
import { withTranslation } from "react-i18next";

import * as styles from './style.css';
import AuthComponentsAuthSocial from "../../components/auth-social";
import { SignInEmailErrorCodeEnum } from "../../../domain/enums/SignInEmailErrorEnum";
import { authByFacebookErrorSelector } from '../../../store/auth-by-facebook/selectors';
import { authByGoogleErrorSelector } from '../../../store/auth-by-google/selectors';
import { resetFacebookErrors } from '../../../store/auth-by-facebook/actions';
import { resetGoogleErrors } from '../../../store/auth-by-google/actions';
import { abeFormErrorsSelector } from "../../../store/auth-by-email/selectors";
import { setFormErrors } from "../../../store/auth-by-email/actions";
import UQFormErrors from "../../../../uq-forms/components/form-errors";
import { currentUserInfoSelector } from "../../../store/auth-user/selectors";
import LayoutComponentsHeader from "../../../../layout/ui/components/header";
import Div100vh from "../../../../uq-ui/components/div-100";
import { createErrorExtractor } from "../../../../uq-forms/helpers";
import { isMemorialType } from "../../../../stickers/store/sticker-show/selectors";

const GreetingImage = require('./greeting.svg');

const errorExtractor = createErrorExtractor({
  email: {
    [SignInEmailErrorCodeEnum.EmailAlreadyInUse]: 'errors.emailAlreadyInUse',
  }
});

class AuthScreensLogin extends PureComponent {

  componentDidMount() {
    this.resetErrors();
    localStorage.setItem('isLoginProcess', "true");
  }

  resetErrors = () => {
    this.props.resetFacebookErrors();
    this.props.resetGoogleErrors();
    this.props.resetFormErrors();
  }

  onBack = () => {
    this.props.history.goBack();
  }

  render() {
    const errors = this.props.fbErrors || this.props.googleErrors;
    const errorCode = errors ? errors.code : null;
    const termsStyle = errorCode ? { marginTop: '3vh' } : {};
    return (
      <Div100vh className={ this.props.isMemorialTheme ? styles.container_memorial : styles.container }>
        <LayoutComponentsHeader showBackBtn={true} 
                                onBack={this.onBack}
                                showLogo={true}
                                theme={ this.props.isMemorialTheme ? 'darkBlue' : 'dark' } />
        <div className={styles.innerTop}>
          <div className={`${ this.props.isMemorialTheme ? styles.title_memorial : styles.title } font-title`}>{this.props.t('hello')}</div>
          <div className={styles.formContainer}>
            <AuthComponentsAuthSocial history={this.props.history}/>
          </div>
          <UQFormErrors textClass={styles.errorText}
                        error={errorExtractor.get('email', errorCode, this.props.t)}/>
          <div className={styles.terms} style={termsStyle}>
            <div className={`${ this.props.isMemorialTheme ? styles.termsText_memorial : styles.termsText } font-text`}>{this.props.t('terms.bySignIn')}</div>
            <div className={`${styles.termsTextBottom} font-text`}>
              <a href="https://www.llama.im/privacy-policy" target="_blank" className={`${ this.props.isMemorialTheme ? styles.termsLink_memorial : styles.termsLink } font-text`}>
                {this.props.t('terms.termsOfUse')}
              </a>
              <span className={`${ this.props.isMemorialTheme ? styles.termsText_memorial : styles.termsText } font-text`}>{this.props.t('terms.and')}</span>
              <a href="https://www.llama.im/terms-of-use" target="_blank" className={`${ this.props.isMemorialTheme ? styles.termsLink_memorial : styles.termsLink } font-text`}>
                {this.props.t('terms.privacyPolicy')}
              </a>
            </div>
          </div>
        </div>
        <div className={styles.innerBottom}>
          <img src={GreetingImage} className={styles.greeting} />
        </div>
      </Div100vh>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    fbErrors: authByFacebookErrorSelector(state),
    googleErrors: authByGoogleErrorSelector(state),
    isMemorialTheme: isMemorialType(state),
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    resetFormErrors: () => dispatch(setFormErrors({})),
    resetFacebookErrors: () => dispatch(resetFacebookErrors()),
    resetGoogleErrors: () => dispatch(resetGoogleErrors())
  }
};

export default compose(
  withTranslation('scr-auth'),
  connect(mapStateToProps, mapDispatchToProps)
)(AuthScreensLogin);



// WEBPACK FOOTER //
// ./src/app/modules/auth/ui/screens/login/index.jsx